import { ElementProps } from "../../../types/common";

export const TelegramIcon = (props: ElementProps) => (
  <svg
    width={11}
    height={11}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#telegram_svg__a)">
      <path
        d="M10.107.976.362 4.753c-.393.176-.525.529-.095.72l2.5.798 6.045-3.755c.33-.236.668-.173.377.087L3.997 7.328l-.163 2c.151.308.428.31.604.156l1.437-1.366 2.46 1.852c.571.34.882.12 1.005-.503l1.614-7.68c.167-.767-.119-1.105-.847-.811Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="telegram_svg__a">
        <path fill="#fff" d="M0 0h11v11H0z" />
      </clipPath>
    </defs>
  </svg>
);
